<form nz-form nzLayout="vertical" novalidate [formGroup]="userForm">
  <div class="row">
    <div class="col-md-12 mb-4" *ngIf="errorMessage !== ''">
    </div>
    <div class="col-md-6">
      <nz-form-item>
        <nz-form-label>User Name</nz-form-label>
        <nz-form-control>
          <input type="text" nz-input placeholder="Please input user name" formControlName="login">
        </nz-form-control>
      </nz-form-item>
    </div>
    <div class="col-md-6">
      <nz-form-item>
        <nz-form-label>Role</nz-form-label>
        <nz-form-control>
          <nz-select class="w-100" nzPlaceHolder="Select roles" formControlName="authorities" [(ngModel)]="selectedAuthority">
            <nz-option *ngFor="let authority of authorities" [nzValue]="authority" [nzLabel]="authority"></nz-option>
          </nz-select>
        </nz-form-control>
      </nz-form-item>
    </div>
  </div>
  <div class="row">
    <div class="col-md-6">
      <nz-form-item>
        <nz-form-label>First Name</nz-form-label>
        <nz-form-control>
          <input type="text" nz-input placeholder="Please input first name" formControlName="firstName">
        </nz-form-control>
      </nz-form-item>
    </div>
    <div class="col-md-6">
      <nz-form-item>
        <nz-form-label>Last Name</nz-form-label>
        <nz-form-control>
          <input type="text" nz-input placeholder="Please input last name" formControlName="lastName">
        </nz-form-control>
      </nz-form-item>
    </div>
  </div>
  <div class="row">
    <div class="col-md-6">
      <nz-form-item>
        <nz-form-label>Phone</nz-form-label>
        <nz-form-control>
          <input type="text" nz-input placeholder="Please input phone" formControlName="phone">
        </nz-form-control>
      </nz-form-item>
    </div>
    <div class="col-md-6">
      <nz-form-item>
        <nz-form-label>Email</nz-form-label>
        <nz-form-control>
          <input type="text" nz-input placeholder="Please input email" formControlName="email">
        </nz-form-control>
      </nz-form-item>
    </div>
  </div>
  <div class="row" *ngIf="this.btnLabel !== 'Update'">
    <div class="col-md-6">
      <nz-form-item>
        <nz-form-label>Password</nz-form-label>
        <nz-form-control>
          <input type="password" nz-input placeholder="Please input password" formControlName="password">
        </nz-form-control>
      </nz-form-item>
    </div>
    <div class="col-md-6">
      <nz-form-item>
        <nz-form-label>Confirm Password</nz-form-label>
        <nz-form-control>
          <input type="password" nz-input placeholder="Please input password" formControlName="confirmPassword">
        </nz-form-control>
      </nz-form-item>
    </div>
  </div>
  <nz-form-item>
    <nz-form-control>
      <div *nzModalFooter>
        <button nz-button nzType="default" (click)="destroyModal()">Cancel</button>
        <button nz-button nzType="primary" (click)="save()" [disabled]="userForm.invalid || isSaving"
                [nzLoading]="isConfirmLoading">{{btnLabel}}
        </button>
      </div>
    </nz-form-control>
  </nz-form-item>
</form>
